export enum IconTypeEnum {
  CardOfDay = "CardOfDay",
  Profile = "Profile",
  Menu = "Menu",
  Home = "Home",
  Category = "Category",
  Spheres = "Spheres",
  Fan = "Fan",
  Search = "Search",
  Fav = "Fav",
  Fav2 = "Fav2",
  Left = "Left",
  Right = "Right",
  Dropdown = "Dropdown",
  Close = "Close",
  Filter = "Filter",
  Loading = "Loading",
  Call = "Call",
  CallIncoming = "CallIncoming",
  CallEnd = "CallEnd",
  CallReconnecting = "CallReconnecting",
  CallConnectionLost = "CallConnectionLost",
  CallSoundOff = "CallSoundOff",
  CallMicrophoneOff = "CallMicrophoneOff",
  Video = "Video",
  VideoBold = "VideoBold",
  VideoOff = "VideoOff",
  Microphone = "Microphone",
  MicrophoneOff = "MicrophoneOff",
  Audio = "Audio",
  Gift = "Gift",
  Tick = "Tick",
  Lock = "Lock",
  Vk = "Vk",
  Ok = "Ok",
  Tg = "Tg",
  Dz = "Dz",
  Time = "Time",
  EyeOn = "EyeOn",
  EyeOff = "EyeOff",
  User = "User",
  Plus = "Plus",
  Payment = "Payment",
  VideoOn = "VideoOn",
  Delete = "Delete",
  Card = "Card",
  ProtectedCard = "ProtectedCard",
  SbpCard = "SbpCard",
  Number = "Number",
  Error = "Error",
  Exclamation = "Exclamation",
  Email = "Email",
  Copy = "Copy",
  WhatsApp = "WhatsApp",
  PayMastercard = "PayMastercard",
  PayVisa = "PayVisa",
  PayMir = "PayMir",
  PayYandex = "PayYandex",
  Reload = "Reload",
  Faq = "Faq",
  Family = "Family",
  Purpose = "Purpose",
  Work = "Work",
  Compatibility = "Compatibility",
  Travel = "Travel",
  Finance = "Finance",
  Other = "Other",
  LogOut = "LogOut",
  Share = "Share",
  Shield = "Shield",
  Fast = "Fast",
  Play = "Play",
  Pause = "Pause",
  Calendar = "Calendar",
  Fire = "Fire",
  Tickets = "Tickets",
  Export = "Export",
  Paper = "Paper",
  Dress = "Dress",
  Concentration = "Concentration",
  Bed = "Bed",
  Food = "Food",
  Info = "Info",
  Certificate = "Certificate",
  Smiley = "Smiley",
  Invitation = "Invitation",
  Chat = "Chat",
  Send = "Send",
  ChatIncoming = "ChatIncoming",
  Like = "Like",
  OldTimer = "OldTimer",
  CrownDark = "CrownDark",
  Crown = "Crown",
  Leaves = "Leaves",
  ArrowRight = "ArrowRight",
  HourGlass = "HourGlass",
  Quote = "Quote",
  Feather = "Feather",
  Aim = "Aim",
  Puzzle = "Puzzle",
  OnboardingFeelingsFemale = "OnboardingFeelingsFemale",
  OnboardingFutureFemale = "OnboardingFutureFemale",
  OnboardingLoveFemale = "OnboardingLoveFemale",
  OnboardingChoiceFemale = "OnboardingChoiceFemale",
  OnboardingWorkFemale = "OnboardingWorkFemale",
  OnboardingFeelingsMale = "OnboardingFeelingsMale",
  OnboardingFutureMale = "OnboardingFutureMale",
  OnboardingChoiceMale = "OnboardingChoiceMale",
  OnboardingWorkMale = "OnboardingWorkMale",
  OnboardingAnother = "OnboardingAnother",
  Vpn = "Vpn",
  Stars = "Stars",
  RightArrow = "RightArrow",
  // Landing Quiz
  QuizStepOneIcon01 = "QuizStepOneIcon01",
  QuizStepOneIcon02 = "QuizStepOneIcon02",
  QuizStepOneIcon03 = "QuizStepOneIcon03",
  QuizStepOneIcon04 = "QuizStepOneIcon04",
  QuizStepTwoIcon01 = "QuizStepTwoIcon01",
  QuizStepTwoIcon02 = "QuizStepTwoIcon02",
  QuizStepTwoIcon03 = "QuizStepTwoIcon03",
  QuizStepTwoIcon04 = "QuizStepTwoIcon04",
  QuizStepThreeIcon01 = "QuizStepThreeIcon01",
  QuizStepThreeIcon02 = "QuizStepThreeIcon02",
  QuizStepThreeIcon03 = "QuizStepThreeIcon03",
  QuizStepThreeIcon04 = "QuizStepThreeIcon04",
  QuizFeatureCardIcon01 = "QuizFeatureCardIcon01",
  QuizFeatureCardIcon02 = "QuizFeatureCardIcon02",
  // Razvod quiz — иконки опций, которых нет среди Quiz* выше
  RazvodStepOneIcon02 = "RazvodStepOneIcon02",
  RazvodStepOneIcon04 = "RazvodStepOneIcon04",
  RazvodStepThreeIcon01 = "RazvodStepThreeIcon01",
  RazvodStepThreeIcon02 = "RazvodStepThreeIcon02",
  RazvodStepThreeIcon03 = "RazvodStepThreeIcon03",
  // Izmenil_muzh quiz — иконки опций экрана 2 (situation), которых нет выше
  IzmenilMuzhStepOneIcon01 = "IzmenilMuzhStepOneIcon01",
  IzmenilMuzhStepOneIcon02 = "IzmenilMuzhStepOneIcon02",
  IzmenilMuzhStepOneIcon04 = "IzmenilMuzhStepOneIcon04",
  // Izmenil_muzh quiz — иконки опций экрана 6 (primaryQuestion), которых нет выше
  IzmenilMuzhStepThreeIcon02 = "IzmenilMuzhStepThreeIcon02",
  IzmenilMuzhStepThreeIcon04 = "IzmenilMuzhStepThreeIcon04",
  // Две встречные стрелки — знак автопродления. Нарисован в сетке 20×20,
  // поэтому рендерится с viewBox={20}, а не в общей тридцатидвойке.
  AutoRenewal = "AutoRenewal",
  // Тот же знак в отдельной отрисовке под плашку в звонке: сетка 13×11, штрихи толще
  // относительно размера, поэтому в мелком кегле читается лучше, чем ужатый AutoRenewal.
  AutoRenewalSmall = "AutoRenewalSmall",
  // Дуга-крутилка 24×24 для компактных мест: common/loader сверстан под полный экран
  // и в маленький контейнер не вписывается.
  Spinner = "Spinner",
}

export enum IconSizeEnum {
  Size80 = "80",
  Size64 = "64",
  Size60 = "60",
  Size48 = "48",
  Size42 = "42",
  Size40 = "40",
  Size36 = "36",
  Size32 = "32",
  Size28 = "28",
  Size24 = "24",
  Size20 = "20",
  Size16 = "16",
  Size14 = "14",
  Size12 = "12",
  Size8 = "8",
}

export type IconProps = {
  type: IconTypeEnum;
  size?: IconSizeEnum;
  title?: string;
  desc?: string;
  viewBox?: number;
  viewBoxHeight?: number
  [x: string]: any;
};
